<template>
<v-container fluid>
<v-layout>
  <v-flex xs12>
   <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
      absolute
      >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
   <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">Edit User</span>
      </v-card-title>

      <v-card-text>
           <v-form ref="form" v-model="valid" lazy-validation>
             <v-row>
              <v-col cols="12"  md="6">
              <v-text-field
               v-model="editedItem.firstName"
               label="First Name"
               :rules="firstNameRules"
               required
               >
               </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
              <v-text-field
               v-model="editedItem.lastName"
               label="Last Name"
               :rules="lastNameRules"
               required
               >
               </v-text-field>
              </v-col>
             </v-row>
             <v-row>
              <v-col cols="12"  md="6">
              <v-text-field
               v-model="editedItem.username"
               label="Username"
               :rules="usernameRules"
               required
               readonly
               >
              </v-text-field>
              </v-col>
             </v-row>
             <v-row>
              <v-col cols="12"  md="6">
              <v-select
                :items="roleNames"
                label="Role"
                v-model="editedItem.role"
                outline
                :rules="roleRules"
                required
              >
              </v-select>
              </v-col>
             </v-row>
             <v-row>
              <v-col cols="12"  md="6">
              <v-select
                :items="activeNames"
                label="Active"
                v-model="editedItem.active"
                outline
                required
              >
              </v-select>
              </v-col>
              <v-col cols="12"  md="6">
              <v-select
                :items="accountStatusNames"
                label="Account Status"
                v-model="editedItem.accountStatus"
                outline
                required
              >
              </v-select>
              </v-col>
             </v-row>
             <v-row>
                <v-col cols="12"  md="6">
                  <v-select v-model="editedItem.department" v-bind:items="departments"  item-text="label"  item-value="value" :placement="placement" label="Department" outline
                                required></v-select>
                </v-col>
             </v-row>
            </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn color="secondary"
                class="accent--text logoutbtn" @click.native="close">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="#7BC243" @click.native="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-card>
    <v-card-title>
       <v-col cols="2">
        <v-btn v-if="canExportUsersReport" color="primary" @click="getUsersExport"> Export Users </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3" color="white">
        <v-text-field v-model="search" append-icon="search" label="Search"
            single-line hide-details color="primary"></v-text-field>
      </v-col>
    </v-card-title>
   <v-card-text>
   <v-data-table
      :headers="headers"
      :items="users"
      class="elevation-1"
      :search="search"
    >
    <template v-slot:[`item.created`]="{ item }">
       {{item.created | prettyDate }}
    </template>
    <template v-slot:[`item.roleId`]="{ item }">
      <p v-if="item.roleId.name"> {{item.roleId.name }} </p>
    </template>
    <template v-slot:[`item.userLogin`]="{ item }">
       <p v-if="item.userLogin == null || item.userLogin.trials < 3"> Not Locked</p>
       <p v-else> Locked </p>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
     <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
          color="primary"
          dark
          v-on="on"
          text
          icon
          class="actions"
        >
          <v-icon class="secondary--text"> more_horiz </v-icon>
        </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="$can('CAN_UPDATE_INTERNALUSERS')" @click="editItem(item)">
            <v-list-item-title> Edit </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    </v-data-table>
   </v-card-text>
  </v-card>
  </v-flex>
</v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'viewinternalusers',
  data: function () {
    return {
      headers: [
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Username', value: 'username' },
        { text: 'Role', value: 'roleId' },
        { text: 'Department', value: 'department' },
        { text: 'Account Status', value: 'userLogin' },
        { text: 'Actions', value: 'actions' }
      ],
      users: [],
      message: '',
      error: '',
      loading: true,
      pagination: {},
      totalUsers: 0,
      dialog: false,
      departments: [{ value: 'ICT', label: 'ICT' }, { value: 'FTS', label: 'FTS' }, { value: 'AGRIC-COOP', label: 'AGRIC-COOP' }, { value: 'BOS', label: 'BOS' }, { value: 'COU', label: 'COU' }, { value: 'AUDIT', label: 'AUDIT' },{ value: 'BRANCH', label: 'BRANCH' },{ value: 'CONTACT CENTRE', label: 'CONTACT CENTRE' }],
      placement: 'down',
      editedIndex: -1,
      defaultItem: {
        firstName: '',
        lastName: '',
        username: '',
        role: '',
        active: '',
        accountStatus: ''
      },
      editedItem: {
        id: '',
        firstName: '',
        lastName: '',
        username: '',
        role: '',
        active: '',
        accountStatus: ''
      },
      roles: [],
      roleNames: [],
      valid: true,
      firstNameRules: [
        v => !!v || 'First Name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last Name is required'
      ],
      usernameRules: [
        v => !!v || 'Username is required'
      ],
      roleRules: [
        v => !!v || 'Role is required'
      ],
      canEditUser: false,
      canExportUsersReport: false,
      accountStatusNames: ['LOCKED', 'NOT_LOCKED'],
      activeNames: ['ACTIVE', 'NOT ACTIVE'],
      snackbarColor: '',
      snackbar: false,
      search: ''
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi()
          .then(data => {
            // this.users = data.items
            // this.totalUsers = data.total
          })
      },
      deep: true
    }
  },
  mounted () {
    this.getDataFromApi()
      .then(data => {
        // this.users = data.items
        // this.totalUsers = data.total
      })

    this.getRoles()
    this.canEditUser = this.canEditUsers()
    this.canExportUsersReport = this.canExportUsers()
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getUsers()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    editItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      if (item.roleId.name) {
        this.editedItem.role =item.roleId.name
      }
      if (item.enabled) {
        this.editedItem.active = 'ACTIVE'
      } else {
        this.editedItem.active = 'NOT_ACTIVE'
      }
      console.log(this.editedItem.active)
      console.log(item.enabled)

      if (item.userLogin && item.userLogin.trials > 3) {
        this.editedItem.accountStatus = 'LOCKED'
      } else {
        this.editedItem.accountStatus = 'NOT_LOCKED'
      }
      this.dialog = true
    },
    canEditUsers () {
      return store.state.user.roleId.permissions.includes('CAN_UPDATE_INTERNALUSERS')
    },
    canExportUsers () {
      return store.state.user.roleId.permissions.includes('CAN_VIEW_INTERNALUSERS')
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.saveUser()
        }
        this.close()
      }
    },
    saveUser () {
      var url = config.serverURI + '/user/internaluser/update'
      console.log(this.editedItem)
      axios.post(url, this.editedItem)
        .then(response => {
          this.message = response.data.message
          if (response.data.error) {
            this.snackbarColor = 'error'
          } else {
            this.snackbarColor = 'primary'
          }
          this.snackbar = true
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
          this.snackbarColor = 'error'
          this.snackbar = true
        })
    },
    getUsers () {
      var url = config.serverURI + '/user/internaluser/get'
      axios.get(url)
        .then(response => {
          console.log('API Response:', response)

          if (response.status !== 200) {
            this.error = response.statusText
            console.log('Error is ' + this.error)
            return
          }
          this.users = response.data
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
        })
      return this.users
    },
    getRoles () {
      var url = config.serverURI + '/admin/role/getAllInternal'
      axios.get(url)
        .then(response => {
          this.roles = response.data
          const mapFunction = p => p.name
          this.roleNames = this.roles.map(mapFunction)
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
        })
    },
    getUsersExport () {
      var url = config.serverURI + '/user/internaluser/extract'
      var token = store.state.token
      axios.get(url, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      })
        .then(response => {
          console.log('API Response:', response)

          if (response.status !== 200) {
            this.error = response.statusText
            console.log('Error is ' + this.error)
            return
          }

          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          var now = new Date()
          var fileName = 'usersexport_' + now + '.xls'
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
          var data = error.response.data
          console.log(data.message)
          if (data.message === 'Unauthorized') {
            console.log('redirecting')
            window.location = '/login'
          } else {
            this.error = data.message
          }
        })
    }
  }
}

</script>
<style>
</style>
